module.exports = __webpack_public_path__ + "static/media/biopharmachemskillnet.c186bc1d.png";